export const TransactionAdBlockType = {
	VOD_START: 'VOD_START',
	VOD_END: 'VOD_END',
};
